import React from 'react';
import "./ModalList.css";

function ModalList() {
    return (
      <>
        <div className="container mt-3">
          <button
            type="button"
            className="btn btn-primary"
            data-bs-toggle="modal"
            data-bs-target="#myModal"
          >
            Click
          </button>
        </div>

        <div className="modal fade" id="myModal">
          <div className="modal-dialog">
            <div className="modal-content rounded-4 shadow">
              <div className="modal-body p-5">
                <h2 className="fw-bold mb-0">What&apos;s new</h2>

                <ul className="d-grid gap-4 my-5 list-unstyled">
                  <li className="d-flex gap-4">
                    {/*
                  <svg
                    className="bi text-muted flex-shrink-0"
                    width="48"
                    height="48"
                  >
                    <use xlinkHref="#grid-fill" />
                  </svg>
                  */}
                    <img
                      src="https://www.marchouben.nl/afbeeldingen/barbara-carrera.jpg"
                      alt="Barbara Carrera"
                      width="48"
                      height="48"
                    />
                    <div>
                      <h5 className="mb-0">Grid view</h5>
                      Not into lists? Try the new grid view.
                    </div>
                  </li>
                  <li className="d-flex gap-4">
                    {/*
                  <svg
                    className="bi text-warning flex-shrink-0"
                    width="48"
                    height="48"
                  >
                    <use xlinkHref="#bookmark-star" />
                  </svg>
                  */}
                    <img
                      src="https://www.marchouben.nl/afbeeldingen/jlo-green-dress.jpg"
                      alt="Jennifer Lopez"
                      width="48"
                      height="48"
                    />
                    <div>
                      <h5 className="mb-0">Bookmarks</h5>
                      Save items you love for easy access later.
                    </div>
                  </li>
                  <li className="d-flex gap-4">
                    {/*
                  <svg
                    className="bi text-primary flex-shrink-0"
                    width="48"
                    height="48"
                  >
                    <use xlinkHref="#film" />
                  </svg>
                  */}
                    <img
                      src="https://www.marchouben.nl/afbeeldingen/monica-bellucci.jpg"
                      alt="Monica Bellucci"
                      width="36"
                      height="36"
                    />
                    <div>
                      <h5 className="mb-0">Video embeds</h5>
                      Share videos wherever you go.
                    </div>
                  </li>
                </ul>
                <button
                  type="button"
                  className="btn btn-lg btn-primary mt-5 w-100"
                  data-bs-dismiss="modal"
                >
                  Great, thanks!
                </button>
              </div>
            </div>
          </div>
        </div>
        </>
    )
}

export default ModalList;